import React from "react";
import PortalLogin from "@/components/PortalLoginShared";
export default function StudentLogin() { return <PortalLogin portalType="student" />; }
